<template>
  <svg :class="['toggle-arrow__icon', {on: on}]" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1812_15709)">
      <path d="M12.0005 13.1707L16.9505 8.2207L18.3645 9.6347L12.0005 15.9987L5.63647 9.6347L7.05047 8.2207L12.0005 13.1707Z" fill="#909090" />
    </g>
    <defs>
      <clipPath id="clip0_1812_15709">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    on: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.toggle-arrow__icon {
  transform: rotate(0deg);

  &.on {
    transform: rotate(180deg);
  }
}
</style>
